// React
import { Fragment, useContext } from "react"

// Components
import { Checkbox, TableNumber } from "components"
import { ChildItem } from "../.."
import { Delete, Update } from "./components"

// Configs
import { theme } from "configs"

// Contexts
import { dataContext } from "pages/Setup/Preference/Location"

// Types
import type { DataList, DataItem } from "../../../../types"

// Utils
import { useToggle } from "utils"
import { DeleteContext } from "pages/Setup/contexts"

export function Item(props: { item: DataList, index: number, dataList: DataItem, refetch: () => void }) {
  const { isActive } = useToggle(false)
  const { currentPage, limit, size, total } = useContext(dataContext)
  const { toggleDeleteData, value } = useContext(DeleteContext)

  return (
    <Fragment>
      <tr>
        <td>{TableNumber({ dataLength: size, pageCurrent: currentPage, index: props.index, limit: limit, totalData: total })}</td>
        <td className="w-[1px]">
          <Checkbox
            value={Boolean(value.find(item => item === props.item.location_id))}
            onClick={() => toggleDeleteData(props.item.location_id)}
          />
        </td>
        <td>{props.item.code}</td>
        <td>{props.item.location_name}</td>
        <td>{props.item.country_name}</td>
        <td>{props.item.province_name}</td>
        <td>{props.item.regency_name}</td>
        <td>{props.item.subdistrict_name}</td>
        <td>{props.item.village_name}</td>
        <td>{props.item.address}</td>
        <td>{props.item.description}</td>
        <td>
          {props.item.location_name !== theme.location_name && (
            <div className="flex justify-center">
              <Update id={props.item} refetch={props.refetch} />
              <Delete id={props.item} refetch={props.refetch} />
            </div>
          )}
        </td>
      </tr>
      {isActive && <ChildItem dataList={props.dataList} refetch={props.refetch} />}
    </Fragment>
  )
}